import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";

import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";

export default observer(function BettingTipQuotaButton(props: {
	tip: BettingTips;
	isInPopup?: boolean;
	store?: BettingTipsStore;
}) {
	const rootStore = useRootAppStore();

	const isSelected = rootStore.betSlipStore.isTipSelected(
		props.tip.bettingOfferId
	);

	const displayTipValue = toDisplayOdd(props.tip.value);

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		rootStore.betSlipStore.addRemoveOffer({
			id: props.tip.bettingOfferId,
			keyId: props.tip.bettingOfferKeyId,
			eventId: props.tip.eventId,
			value: props.tip.value,
		});

		if (props.isInPopup) {
			props.store?.deactivatePopup();
		}
	};

	const quotaClasses = classNames({
		"card--bbp__quota quote quote--button quote--button--bbp btn btn--block":
			!props.isInPopup,
		"popup--most__btn quote--button btn btn--med btn--block":
			props.isInPopup,
		"is-active": isSelected,
	});

	return (
		<>
			<button
				type="button"
				className={quotaClasses}
				onClick={handleClick}
				title={props.tip.value.toFixed(2)}
			>
				<strong className="quote--button__odd u-type--center">
					{displayTipValue}
				</strong>
			</button>
		</>
	);
});
